module.exports = {
	"root": "findify-components--category-facet",
	"nested": "findify-components--category-facet__nested",
	"content": "findify-components--category-facet__content",
	"item": "findify-components--category-facet__item",
	"active": "findify-components--category-facet__active",
	"expand": "findify-components--category-facet__expand"
};